import { ref } from 'vue'
import { useCoverageCalculation } from './useCoverageCalculation'

export function usePingAnimation() {
  const { calculateCoverageRadiusMeters } = useCoverageCalculation()
  const pingingSatelliteNames = ref([])
  const activePings = ref([])
  let animationFrameId = null

  function animatePings() {
    const now = performance.now();

    // Filter out completed pings first
    const updatedPings = activePings.value.filter(ping => {
      const elapsedTime = now - ping.startTime;
      return elapsedTime < ping.duration;
    });

    // Update properties for remaining pings
    activePings.value = updatedPings.map(ping => {
      const elapsedTime = now - ping.startTime;
      const progress = elapsedTime / ping.duration;

      // Ease-out function for radius growth
      const easedProgress = 1 - Math.pow(1 - progress, 3); // cubic ease-out

      const currentRadius = ping.maxRadius * easedProgress;
      const opacity = 0.4 * (1 - progress); // Fade out linearly, start at 0.4

      return { ...ping, currentRadius, opacity };
    });

    // Update the list of pinging satellite names from active pings
    pingingSatelliteNames.value = [...new Set(activePings.value.map(p => p.satelliteName).filter(Boolean))];

    // Continue animation if there are active pings
    if (activePings.value.length > 0) {
      animationFrameId = requestAnimationFrame(animatePings);
    } else {
      animationFrameId = null; // Stop the loop when no pings are active
    }
  }

  function createPingForSatellite(satellite) {
    if (typeof satellite.altitude === 'number') {
      const maxRadius = calculateCoverageRadiusMeters(satellite.altitude);
      if (maxRadius > 0) {
        activePings.value.push({
          id: Date.now() + Math.random(),
          lat: satellite.lat,
          lng: satellite.lng,
          startTime: performance.now(),
          duration: 2500, // ms
          maxRadius: maxRadius,
          satelliteName: satellite.name,
        });

        // Start animation loop if not already running
        if (!animationFrameId) {
          animatePings();
        }
      }
    }
  }

  function cleanup() {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }
  }

  return {
    pingingSatelliteNames,
    activePings,
    createPingForSatellite,
    cleanup
  }
}